class CartMini extends HTMLElement {
    constructor() {
        super();

        Shopify.money_format =
            '{{amount_no_decimals_with_comma_separator}}' +
            ' ' +
            Shopify.currency.active;

        Shopify.formatMoney = function (cents, format) {
            if (typeof cents == 'string') {
                cents = cents.replace('.', '');
            }

            var value = '';
            var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
            var formatString = format || this.money_format;

            function defaultOption(opt, def) {
                return typeof opt == 'undefined' ? def : opt;
            }

            function formatWithDelimiters(number, precision, thousands, decimal) {
                precision = defaultOption(precision, 2);
                thousands = defaultOption(thousands, ',');
                decimal = defaultOption(decimal, '.');

                if (isNaN(number) || number == null) {
                    return 0;
                }

                number = (number / 100.0).toFixed(precision);

                var parts = number.split('.'),
                    dollars = parts[0].replace(
                        /(\d)(?=(\d\d\d)+(?!\d))/g,
                        '$1' + thousands
                    ),
                    cents = parts[1] ? decimal + parts[1] : '';

                return dollars + cents;
            }

            switch (formatString.match(placeholderRegex)[1]) {
                case 'amount':
                    value = formatWithDelimiters(cents, 2);
                    break;
                case 'amount_no_decimals':
                    value = formatWithDelimiters(cents, 0);
                    break;
                case 'amount_with_comma_separator':
                    value = formatWithDelimiters(cents, 2, '.', ',');
                    break;
                case 'amount_no_decimals_with_comma_separator':
                    value = formatWithDelimiters(cents, 0, '.', ',');
                    break;
            }

            return formatString.replace(placeholderRegex, value);
        };

        let addButtons = document.querySelectorAll('.cart-suggestions .add');

        addButtons.forEach((button) => {
            button.addEventListener('click', this.addItemToCart.bind(this));
        });

        let closeButton = document.querySelector('.mini-cart .close');

        if (closeButton) {
            closeButton.addEventListener('click', this.closeCart);
        }

        this.suggestionsInitialized = false;
        this.cartObserver = null;

        this.freeGift = new window.CartFreeGift(this);
        this.querySelector('.checkout-action a')?.addEventListener('click', async (event) => {
            event.preventDefault();
            if (this.checkingOut) return;
            this.checkingOut = true;
            try {
                await this.loadCart();
                if (!this.giftSyncError && this.lastCart?.item_count) {
                    window.location.assign(event.currentTarget?.href || this.querySelector('.checkout-action a').href);
                }
            } finally {
                this.checkingOut = false;
            }
        });
        this.loadCart();
    }

    enqueueCartTask(task) {
        const queued = (this.cartQueue || Promise.resolve()).catch(() => {}).then(task);
        this.cartQueue = queued;
        return queued;
    }

    loadCart() {
        return this.enqueueCartTask(() => this.renderCart());
    }

    getCartVariantMetafields() {
        const cartVariantMetafieldsEl = document.querySelector('#CartVariantMetafieldsJson');

        if (!cartVariantMetafieldsEl) {
            return {};
        }

        try {
            return JSON.parse(cartVariantMetafieldsEl.textContent);
        } catch (error) {
            console.error('CartVariantMetafieldsJson error:', error);
            return {};
        }
    }

    async refreshCartVariantMetafieldsJson() {
        try {
            const response = await fetch(
                window.location.pathname + '?timestamp=' + new Date().getTime(),
                {
                    method: 'GET',
                    headers: {
                        'X-Requested-With': 'xmlhttprequest',
                        'Cache-Control': 'no-cache',
                    },
                }
            );

            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            const newJson = doc.querySelector('#CartVariantMetafieldsJson');
            const currentJson = document.querySelector('#CartVariantMetafieldsJson');

            if (newJson && currentJson) {
                currentJson.textContent = newJson.textContent;
            }

            if (newJson && !currentJson) {
                document.body.appendChild(newJson.cloneNode(true));
            }
        } catch (error) {
            console.error('Error refreshing CartVariantMetafieldsJson:', error);
        }
    }

    getLineVariantInfo(product) {
        const variantId = product.variant_id || product.id;
        const cartVariantMetafields = this.getCartVariantMetafields();
        const cartVariantData = cartVariantMetafields[String(variantId)];

        let colorName = '';

        if (cartVariantData && cartVariantData.color_name) {
            colorName = cartVariantData.color_name;
        }

        let sizeName =
            product.properties && product.properties._Size
                ? product.properties._Size
                : '';

        if (!sizeName && product.options_with_values) {
            const sizeOption = product.options_with_values.find((option) => {
                return (
                    option.name &&
                    option.name.toLowerCase() === 'size'
                );
            });

            if (sizeOption && sizeOption.value) {
                sizeName = sizeOption.value;
            }
        }

        return {
            colorName,
            sizeName,
        };
    }

    async renderCart() {
        try {
            this.giftSyncError = true;
            let headers = new Headers();
            headers.append('Pragma', 'no-cache');
            headers.append('Cache-Control', 'no-cache');
            headers.append('Expires', '0');

            let options = {
                method: 'GET',
                headers: headers,
            };

            await fetch('/cart.js?timestamp=' + new Date().getTime(), options)
                .then((response) => {
                    if (!response.ok) throw new Error('Unable to load cart');
                    return response.json();
                })
                .then(async (data) => {
                    const previousCart = JSON.stringify(data.items.map((item) => [item.key, item.quantity]));
                    data = await this.freeGift.reconcile(data);
                    this.lastCart = data;
                    this.giftSyncError = false;
                    // Keep the full cart page in step when reconciliation changes its lines.
                    if (document.querySelector('cart-items') && previousCart !== JSON.stringify(data.items.map((item) => [item.key, item.quantity]))) {
                        document.dispatchEvent(new CustomEvent('cart:gift-updated'));
                    }
                    const cartContent = document.querySelector('.cart-content');

                    if (!cartContent) {
                        return;
                    }

                    if (data.items.length) {
                        let itemNumber = 0;

                        const emptyText = document.querySelector(
                            '.mini-cart .text .empty'
                        );

                        const fullText = document.querySelector(
                            '.mini-cart .text .full'
                        );

                        if (emptyText) {
                            emptyText.classList.remove('show');
                        }

                        if (fullText) {
                            fullText.classList.add('show');
                        }

                        cartContent.innerHTML = '';

                        data.items.forEach((product) => {
                            const isGift = window.CartFreeGift.isGift(product);
                            const lineKey = product.key || product.id;
                            const variantId = product.variant_id || product.id;

                            const preorderNote =
                                product.properties && product.properties._Preorder2
                                    ? `<div class="preorder-note">${product.properties._Preorder2}</div>`
                                    : '';

                            const variantData = this.getLineVariantInfo(product);
                            const colorName = variantData.colorName;
                            const sizeName = variantData.sizeName;

                            const variantInfo = `
                                ${
                                    colorName && colorName !== 'Default Title'
                                        ? `<div class="cart-variant-option cart-variant-color">Color ${colorName}</div>`
                                        : ''
                                }
                                ${
                                    sizeName && sizeName !== 'Default Title'
                                        ? `<div class="cart-variant-option cart-variant-size">Size ${sizeName}</div>`
                                        : ''
                                }
                            `;

                            const imageHtml =
                                product.featured_image && product.featured_image.url
                                    ? `
                                        <img
                                            src="${product.featured_image.url}"
                                            loading="lazy"
                                            alt="${product.product_title}"
                                            width="${product.featured_image.width}"
                                            height="${product.featured_image.height}"
                                        >
                                    `
                                    : '';

                            cartContent.innerHTML += `
                                <div 
                                    class="cart-item item-${variantId}${isGift ? ' cart-item--gift' : ''}" 
                                    data-id="${lineKey}" 
                                    data-key="${lineKey}"
                                    data-variant-id="${variantId}"
                                >
                                    <div class="image">
                                        <a href="${product.url}">
                                            ${imageHtml}
                                        </a>
                                    </div>

                                    <div class="info">
                                        <div class="info2">
                                            <span class="name">${product.product_title}</span>

                                            <div class="container_price">
                                                <div class="price">
                                                    <span class="quantity">${product.quantity}</span> X
                                                    ${isGift && product.original_price > 0 ? `<s>${Shopify.formatMoney(product.original_price)}</s> ` : ''}
                                                    ${Shopify.formatMoney(product.final_price)}
                                                    ${isGift ? '<span class="cart-gift-label">Gift</span>' : ''}
                                                </div>

                                                ${!isGift ? `<a
                                                    href="javascript:" 
                                                    data-id="${lineKey}" 
                                                    class="remove_all" 
                                                    rel="nofollow"
                                                >
                                                    Remove
                                                </a>` : ''}
                                            </div>
                                        </div>

                                        ${preorderNote}

                                        ${variantInfo}

                                        ${!isGift ? `<div
                                            class="quantity_buttons" 
                                            role="group" 
                                            aria-label="Quantity controls for ${product.product_title}"
                                        >
                                            <button 
                                                type="button" 
                                                data-id="${lineKey}" 
                                                class="remove_quantity" 
                                                aria-label="Decrease quantity of ${product.product_title}"
                                            >
                                                -
                                            </button>

                                            <span 
                                                class="quantity-value" 
                                                aria-live="polite"
                                                aria-label="Quantity: ${product.quantity}"
                                            >
                                                ${product.quantity}
                                            </span>

                                            <button 
                                                type="button" 
                                                data-id="${lineKey}" 
                                                data-variant-id="${variantId}" 
                                                class="add_quantity" 
                                                aria-label="Increase quantity of ${product.product_title}"
                                            >
                                                +
                                            </button>
                                        </div>` : ''}
                                    </div>
                                </div>
                            `;

                            itemNumber += product.quantity;
                        });

                        const miniCartNumber = document.querySelector(
                            '.mini-cart .text .number'
                        );

                        if (miniCartNumber) {
                            miniCartNumber.innerHTML = itemNumber;
                        }

                        let checkoutButton = document.querySelector(
                            '.mini-cart .checkout-action'
                        );

                        if (checkoutButton) {
                            checkoutButton.classList.remove('disabled');
                        }
                    } else {
                        const emptyText = document.querySelector(
                            '.mini-cart .text .empty'
                        );

                        const fullText = document.querySelector(
                            '.mini-cart .text .full'
                        );

                        if (emptyText) {
                            emptyText.classList.add('show');
                        }

                        if (fullText) {
                            fullText.classList.remove('show');
                        }

                        cartContent.innerHTML = '';

                        let checkoutButton = document.querySelector(
                            '.mini-cart .checkout-action'
                        );

                        if (checkoutButton) {
                            checkoutButton.classList.add('disabled');
                        }
                    }

                    let removeAllButtons = document.querySelectorAll(
                        '.mini-cart .remove_all'
                    );

                    removeAllButtons.forEach((button) => {
                        button.addEventListener(
                            'click',
                            this.removeAllFromCart.bind(this)
                        );
                    });

                    let addButtons = document.querySelectorAll(
                        '.mini-cart .add_quantity'
                    );

                    let removeButtons = document.querySelectorAll(
                        '.mini-cart .remove_quantity'
                    );

                    addButtons.forEach((button) => {
                        button.addEventListener(
                            'click',
                            this.addItemQuantity.bind(this)
                        );
                    });

                    removeButtons.forEach((button) => {
                        button.addEventListener(
                            'click',
                            this.removeItemFromCart.bind(this)
                        );
                    });

                    let quantities = document.querySelectorAll(
                        '.mini-cart .quantity'
                    );

                    let itemCount = 0;

                    quantities.forEach((quantity) => {
                        itemCount += parseInt(quantity.innerHTML);
                    });

                    const cartItemCount = document.querySelector('#cart-item-count');

                    if (cartItemCount) {
                        cartItemCount.innerHTML = 'Bag (' + itemCount + ')';
                    }

                    const mobileHeaderBag = document.querySelector(
                        'sticky-header .mobileHeader .left'
                    );

                    if (mobileHeaderBag) {
                        mobileHeaderBag.innerHTML = 'Bag (' + itemCount + ')';
                    }

                    const menuRight = document.querySelector(
                        'sticky-header .structure .menu-right'
                    );

                    if (menuRight) {
                        menuRight.classList.add('show');
                    }

                    this.observe();

                    document.body.classList.remove('mobile-mini-cart-full');

                    const miniCartContent = document.querySelector(
                        '.mini-cart .cart-content'
                    );

                    if (miniCartContent && miniCartContent.childElementCount > 0) {
                        document.body.classList.add('mobile-mini-cart-full');
                    }

                    window.localStorage.setItem('cart-count', data.item_count);

                    this.updateCartTotal(data);
                    this.removeVariationDefaultTitle();
                    this.checkSuggestions(data);
                });
        } catch (err) {
            this.giftSyncError = true;
            const message = this.querySelector('[data-gift-message]');
            if (message && this.freeGift.enabled) {
                message.textContent = 'Unable to update your bag. Please try again before checkout.';
                this.querySelector('[data-gift-progress]').hidden = false;
            }
            console.error(err);
        }
    }

    updateCartTotal(data) {
        const cartTotal = document.querySelector('.cart_ctotal strong');

        if (!cartTotal || !data) {
            return;
        }

        cartTotal.innerHTML = Shopify.formatMoney(data.total_price);
    }

    async addDiscount() {
        fetch(`/discount/CLOSEFRIENDS`)
            .then(function () {
                return fetch('/cart/update.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        updates: {},
                    }),
                });
            })
            .catch(function (error) {
                console.error('Error:', error);
            });
    }

    observe() {
        const cartContent = document.querySelector('.cart-content');

        if (!cartContent) {
            return;
        }

        if (this.cartObserver) {
            this.cartObserver.disconnect();
        }

        this.cartObserver = new MutationObserver(function (mutations_list) {
            mutations_list.forEach(function (mutation) {
                if (mutation.type == 'childList') {
                    document.body.classList.remove('mobile-mini-cart-full');

                    const miniCartContent = document.querySelector(
                        '.mini-cart .cart-content'
                    );

                    if (miniCartContent && miniCartContent.childElementCount > 0) {
                        document.body.classList.add('mobile-mini-cart-full');
                    }
                }
            });
        });

        this.cartObserver.observe(cartContent, {
            subtree: false,
            childList: true,
        });
    }

    removeVariationDefaultTitle() {
        let variations = document.querySelectorAll('.variation');

        variations.forEach((variation) => {
            if (variation.innerHTML == 'Default Title') {
                variation.remove();
            }
        });
    }

    updatePrioritySuggestions(data) {
        const cartProductIds = new Set(
            data.items.map((item) => String(item.product_id))
        );

        const activePriorityProductIds = new Set();
        const prioritySuggestions = document.querySelectorAll(
            '.mini-cart .priority'
        );

        prioritySuggestions.forEach((suggestion) => {
            const parentId = suggestion.dataset.priorityParentId;
            const productId = suggestion.dataset.productId;
            const shouldShow =
                cartProductIds.has(parentId) && !cartProductIds.has(productId);

            suggestion.classList.toggle('show', shouldShow);
            suggestion.classList.toggle('hide', !shouldShow);

            if (shouldShow) {
                activePriorityProductIds.add(productId);
            }
        });

        document
            .querySelectorAll('.mini-cart .secondary, .mini-cart .main')
            .forEach((suggestion) => {
                const isDuplicate = activePriorityProductIds.has(
                    suggestion.dataset.productId
                );

                if (
                    isDuplicate &&
                    !suggestion.classList.contains('priority-duplicate')
                ) {
                    suggestion.dataset.priorityWasVisible = suggestion.classList.contains(
                        'hide'
                    )
                        ? 'false'
                        : 'true';
                    suggestion.classList.add('priority-duplicate', 'hide');
                    suggestion.classList.remove('show');
                }

                if (
                    !isDuplicate &&
                    suggestion.classList.contains('priority-duplicate')
                ) {
                    const wasVisible =
                        suggestion.dataset.priorityWasVisible === 'true';

                    suggestion.classList.toggle('show', wasVisible);
                    suggestion.classList.toggle('hide', !wasVisible);
                    suggestion.classList.remove('priority-duplicate');
                    delete suggestion.dataset.priorityWasVisible;
                }
            });

        return activePriorityProductIds;
    }

    limitVisibleSuggestions(maxVisible = 4) {
        const suggestions = Array.from(
            document.querySelectorAll(
                '.mini-cart .cart-suggestions .productThumbnail'
            )
        );

        suggestions.forEach((suggestion) => {
            suggestion.classList.remove('suggestion-over-limit');
        });

        suggestions
            .filter((suggestion) => !suggestion.classList.contains('hide'))
            .forEach((suggestion, index) => {
                suggestion.classList.toggle(
                    'suggestion-over-limit',
                    index >= maxVisible
                );
            });
    }

    checkSuggestions(data) {
        const activePriorityProductIds = this.updatePrioritySuggestions(data);

        if (this.suggestionsInitialized) {
            this.limitVisibleSuggestions();
            return;
        }

        this.suggestionsInitialized = true;

        let currentSecondaries = document.querySelectorAll(
            '.mini-cart .secondary'
        );

        let currentCartItems = document.querySelectorAll(
            '.mini-cart .cart-item'
        );

        currentCartItems.forEach((product) => {
            let id = product.getAttribute('data-variant-id');
            let suggestions = document.querySelectorAll('.product-' + id);

            suggestions.forEach((suggestion) => {
                if (!suggestion.classList.contains('priority')) {
                    suggestion.remove();
                }
            });
        });

        currentSecondaries = Array.from(
            document.querySelectorAll('.mini-cart .secondary')
        ).filter((suggestion) => {
            return !activePriorityProductIds.has(suggestion.dataset.productId);
        });

        let index = 0;

        let secondariesArrayIndex = Array(currentSecondaries.length)
            .fill(0)
            .map(() => index++);

        let shuffled = secondariesArrayIndex
            .map((value) => ({ value, sort: Math.random() }))
            .sort((a, b) => a.sort - b.sort)
            .map(({ value }) => value);

        currentSecondaries.forEach((secondary) => {
            secondary.classList.remove('show');
            secondary.classList.add('hide');
        });

        let mainPresent = document.querySelector('.productThumbnail.main');

        if (currentSecondaries.length >= 2) {
            currentSecondaries[shuffled[0]].classList.add('show');
            currentSecondaries[shuffled[0]].classList.remove('hide');

            currentSecondaries[shuffled[1]].classList.add('show');
            currentSecondaries[shuffled[1]].classList.remove('hide');
        }

        if (!mainPresent && currentSecondaries.length >= 3) {
            currentSecondaries[shuffled[2]].classList.add('show');
            currentSecondaries[shuffled[2]].classList.remove('hide');
        }

        if (
            document.querySelectorAll('.mini-cart .secondary').length == 0 &&
            document.querySelectorAll('.mini-cart .priority').length == 0
        ) {
            let cartSuggestions = document.querySelector('.cart-suggestions');

            if (cartSuggestions) {
                cartSuggestions.remove();
            }
        }

        this.limitVisibleSuggestions();
    }

    async changeCartLine(event, difference) {
        event.preventDefault();
        const button = event.currentTarget;
        const key = button.getAttribute('data-id');
        const quantity = Number(button.closest('.cart-item').querySelector('.quantity').textContent);
        button.disabled = true;
        try {
            await this.enqueueCartTask(async () => {
                await this.freeGift.request('/change', {
                    id: key,
                    quantity: difference === null ? 0 : Math.max(0, quantity + difference),
                });
                await this.refreshCartVariantMetafieldsJson();
                await this.renderCart();
            });
        } catch (error) {
            console.error(error);
            await this.loadCart();
        } finally {
            button.disabled = false;
        }
    }

    removeAllFromCart(event) {
        return this.changeCartLine(event, null);
    }

    removeItemFromCart(event) {
        return this.changeCartLine(event, -1);
    }

    addItemQuantity(event) {
        return this.changeCartLine(event, 1);
    }

    async addItemToCart(event) {
        event.preventDefault();
        const button = event.currentTarget;
        if (button.getAttribute('aria-disabled') === 'true') return;
        const id = button.getAttribute('data-id');
        button.setAttribute('aria-disabled', 'true');
        try {
            return await this.enqueueCartTask(async () => {
                const data = await this.freeGift.request('/add', { items: [{ id, quantity: 1 }] });
                await this.refreshCartVariantMetafieldsJson();
                await this.renderCart();
                return data;
            });
        } catch (error) {
            console.error(error);
            await this.loadCart();
            return null;
        } finally {
            button.removeAttribute('aria-disabled');
        }
    }

    show(force) {
        document.body.classList.toggle('cart-opened');

        if (force) {
            document.body.classList.add('cart-opened');
        }

        document.body.classList.remove('search-opened');
        document.body.classList.remove('menu-opened');

        let mobileMenuOpener = document.querySelector('.mobileMenuOpener');

        if (isTouchDevice()) {
            if (mobileMenuOpener && mobileMenuOpener.innerHTML == 'Close') {
                mobileMenuOpener.innerHTML = 'Menu';
            }
        }

        this.scroll(0, 0);
    }

    closeCart() {
        document.body.classList.remove('cart-opened');
    }
}

customElements.define('cart-mini', CartMini);
